import {Spin} from 'antd';
import React, {FC} from 'react';

import {CustomCard} from 'components/@common/widgets/custom-card';
import {UIBlocker} from 'components/ui-blocker';
import {useAppSelector} from 'store/config/hooks';
import {selectIsThunkPending, selectThunkError} from 'store/slices/loading-state-slice';

import {fetchForecastComments} from '../../api/thunks';
import {FORECAST_COMMENTS_PAGE_TITLE} from '../../model/constants';
import {ForecastCommentsActionPanel} from '../action-panel/action-panel';
import {ForecastCommentsFilters} from '../filters/filters';
import {ForecastCommentsTable} from '../table/table';

export const ForecastCommentsPage: FC = () => {
    const isLoading = useAppSelector((st) => selectIsThunkPending(st, fetchForecastComments.typePrefix));
    
    const loadError = useAppSelector((st) => selectThunkError(st, fetchForecastComments.typePrefix));

    return (
        <div>
            <Spin
                spinning={isLoading}
                tip="Загрузка данных..."
            >
                <CustomCard
                    title={FORECAST_COMMENTS_PAGE_TITLE}
                    accordionContent={<ForecastCommentsFilters />}
                    isAccordionContentVisibleByDefault
                >
                    <UIBlocker thunkError={{error: loadError, verbose: true}}>
                        <ForecastCommentsActionPanel />
                        <ForecastCommentsTable />
                    </UIBlocker>
                </CustomCard>
            </Spin>
        </div>
    );
};

ForecastCommentsPage.displayName = 'ForecastCommentsPage';
